// @flow

import * as React from "react";
import { useSelector, useDispatch } from "react-redux";

import { loginWithRedirect } from "../../actions/user";
import formatCurrency from "../../utils/formatCurrency";
import Config from "../../constants/Config";
import PromoCode from "../molecules/PromoCode";
import Button from "../atoms/Button";
import TextButton from "../atoms/TextButton";

type PropsType = {
    itemsCount: number,
    subTotal: number,
    total: number,
    deliveryRequired?: boolean,
    promoCodes?: [],
    className?: string,
};

const CartSummary = (props: PropsType): React.Node => {
    const dispatch = useDispatch();
    const { loggedIn } = useSelector((state: any): any => state.user);

    const cssBaseClass = "cart-summary";
    const classList = [cssBaseClass];
    if (props.className) {
        classList.push(props.className);
    }

    const handleLoginToCheckout = () => {
        dispatch(loginWithRedirect(document.location.pathname));
    };

    return (
        <div className={classList.join(" ")}>
            <div className="cart-summary__header">
                <div className="cart-summary__header__title">Order summary</div>
                <div className="cart-summary__header__value">
                    {props.itemsCount}{" "}
                    {`item${props.itemsCount !== 1 ? "s" : ""}`}
                </div>
            </div>

            {/* Subtotal */}
            <div className="cart-summary__line">
                <div className="cart-summary__line__title">
                    Subtotal (GST incl.)
                </div>
                <div className="cart-summary__line__value">
                    {formatCurrency(props.subTotal)}
                </div>
            </div>

            {/* Applied promo/coupons */}
            {props.promoCodes
                ? props.promoCodes.map((promoCode: any, index: number) => {
                      return (
                          <div key={index} className="cart-summary__line">
                              <div className="cart-summary__line__title">
                                  Promo code - <strong>{promoCode.code}</strong>
                              </div>
                              {promoCode.totals ? (
                                  <div className="cart-summary__line__value">
                                      -
                                      {formatCurrency(
                                          Number(
                                              promoCode.totals.total_discount
                                          ) +
                                              Number(
                                                  promoCode.totals
                                                      .total_discount_tax
                                              )
                                      )}
                                  </div>
                              ) : null}
                          </div>
                      );
                  })
                : null}

            {/* Delivery */}
            {props.deliveryRequired ? (
                <div className="cart-summary__line">
                    <div className="cart-summary__line__title">Delivery</div>
                    <div className="cart-summary__line__value">
                        Calculated at checkout
                    </div>
                </div>
            ) : null}

            {/* Total */}
            <div className="cart-summary__footer">
                <div className="cart-summary__footer__title">Total</div>
                <div className="cart-summary__footer__value">
                    {formatCurrency(props.total)}
                </div>
            </div>

            {/* Promo code */}
            <PromoCode className="cart-summary__promo-code" />

            {/* Continue to checkout login/logged out state */}
            {loggedIn ? (
                <Button
                    to={Config.routes.checkout}
                    styles={["green"]}
                    className="cart-summary__checkout-btn"
                >
                    Checkout
                </Button>
            ) : (
                <div className="cart-summary__logged-out">
                    <Button
                        onClick={handleLoginToCheckout}
                        styles={["green"]}
                        className="cart-summary__checkout-btn"
                    >
                        Login or sign up to continue
                    </Button>
                    <Button
                        to={Config.routes.checkout}
                        styles={["green-secondary"]}
                        className="cart-summary__checkout-btn--guest"
                    >
                        Checkout as guest
                    </Button>

                    <p>
                        Sign in with your UTS ID to receive a{" "}
                        <strong>10% discount</strong> on eligible products.
                    </p>
                </div>
            )}
        </div>
    );
};

export default CartSummary;
